// extracted by mini-css-extract-plugin
export default {"root":"t6g4L","text":"GrfsN"};